<template>
  <main class="purchase-main">
    <app-loading v-if="isLoading"></app-loading>
    <div v-else>
      <ul class="radio-cards">
        <li v-for="paymentWay in getPaymentsWays()" @click="choosePaymentsWay(paymentWay[0])"><a href="javascript:void(0);" :class="{'is-active': paymentWay[0] === selectedPaymentsWay}" class="radio-card">{{paymentWay[1]}}</a></li>
      </ul>
      <div class="purchase-main__next">
        <span class="btn-square" @click="select_payment()" v-if="selectedPaymentsWay">選択</span>
        <span class="btn-square btn-square--disabled" v-else>選択</span>
      </div>
    </div>
  </main>
</template>

<script>
  import { paymentsWays, credit, merchantId, serviceId } from '../../constants';
  import { SHA1 } from 'crypto-js'
  import $ from 'jquery';
  import Loading from '../common/Loading.vue';
  import store from '../../store/store';

  export default {
    title: '購入方法選択 - abceed',
    headerTitle: '購入方法選択',
    description: '',
    keywords: '',
    headerType: 'historyBack',
    components: {
      appLoading: Loading
    },
    data() {
      return {
        paymentsWays,
        selectedPaymentsWay: null
      }
    },
    beforeCreate() {
      if (this.$store.getters.directLanding && (this.$route.name === 'creditCard' || this.$route.name === 'paymentWay')) {
        this.$router.push({ name: 'bookDetail', params: { id: this.$route.params.id }});
      }
    },
    computed: {
      isLoading() {
        return this.$store.getters.isLoading;
      }
    },
    methods: {
      getPaymentsWays() {
        const ua = window.navigator.userAgent.toLowerCase();
        if (ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1 && ua.indexOf('crios') === -1) {
          //SafariならApplePay付きで返す
          return paymentsWays;
        }
        return paymentsWays.filter(way => {
          return way[0] !== "applepay";
        });
      },
      choosePaymentsWay(index) {
        this.selectedPaymentsWay = index;
      },
      select_payment() {
        const detail = this.$store.getters.bookDetail;
        const idUser = window.localStorage.getItem(['userId']);
        if (this.selectedPaymentsWay === credit) {
          //クレカの場合はクレジットカード情報入力画面へ
          this.$router.push({name: 'creditCard'});
        } else {
          //クレカ以外の場合はSBPSのリンクへ直接接続
          const order_id = generateUuid();
          //ログ送信
          f_submit(idUser, this.selectedPaymentsWay,
            detail.id_book, detail.name_book, detail.discounted_price_jp, order_id)
        }
      }
    }
  }

  function f_submit(id_user, payment, book_id, item_name, item_price, order_id) {
    let item_tax = item_price - Math.floor(item_price / 1.08);
    let callback_url = "https://store.abceed.com/books/" + book_id + "";
    let order = new Order();
    item_name = item_name.replace('゙', '');
    item_name = item_name.replace('゙', '');
    item_name = item_name.replace('゙', '');
    item_name = item_name.replace('®', '');

    order.pay_method            = payment;
    order.merchant_id           = merchantId;
    order.service_id            = serviceId;
    order.cust_code             = id_user;
    order.sps_cust_no           = "";
    order.sps_payment_no        = "";
    order.order_id              = order_id;
    order.item_id               = book_id;
    order.pay_item_id           = "";
    order.item_name             = item_name;
    order.tax                   = item_tax + "";
    order.amount                = item_price + "";
    order.pay_type              = "0";
    order.auto_charge_type      = "";
    order.service_type          = "0";
    order.div_settele           = "";
    order.last_charge_month     = "";
    order.camp_type             = "";
    order.tracking_id           = "";
    order.terminal_type         = "0";
    order.success_url           = callback_url + "?result=ok";
    order.cancel_url            = callback_url + "?result=cancel";
    order.error_url             = callback_url + "?result=error";
    order.pagecon_url           = "https://api.abceed.com/webstore/book/purchase/sbps";
    order.free1                 = "";
    order.free2                 = "";
    order.free3                 = "";
    order.request_date          = getYYYYMMDDHHMMSS();
    order.limit_second          = "";
    order.hashkey               = "7122bf71a8517c1395806ae9b98882cdd0c967fc";
    //チェックサム
    order.sps_hashcode          = SHA1( order.toString() );

    const action = {
      id_book: book_id,
      action_type: "click_payment_link",
      supplement: order.toJsonString()
    };
    store.dispatch("sendAction", action);
    feppost(order);
  }

  function generateUuid() {
    // https://github.com/GoogleChrome/chrome-platform-analytics/blob/master/src/internal/identifier.js
    // const FORMAT: string = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
    let chars = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".split("");
    for (let i = 0, len = chars.length; i < len; i++) {
      switch (chars[i]) {
        case "x":
          chars[i] = Math.floor(Math.random() * 16).toString(16);
          break;
        case "y":
          chars[i] = (Math.floor(Math.random() * 4) + 8).toString(16);
          break;
      }
    }
    return chars.join("");
  }

  // オブジェクト定義[OrderDetail]
  function OrderDetail()
  {
    this.toString = function() {
      let result =
        this.dtl_rowno +
        this.dtl_item_id +
        this.dtl_item_name +
        this.dtl_item_count +
        this.dtl_tax +
        this.dtl_amount +
        this.dtl_free1 +
        this.dtl_free2 +
        this.dtl_free3;
      return result;
    }
  }

  // オブジェクト定義[Order]
  function Order()
  {
    this.orderDetail = new Array();
    this.toJsonString = function() {
      let resultOrderDetail = "";
      const orderLength = this.orderDetail.length;
      for (let i = 0; i < orderLength; i++) {
        const o = this.orderDetail[i];
        resultOrderDetail = resultOrderDetail + o.toString();
      }

      let result =
        '{"pay_method":"'+ this.pay_method + '",' +
        '"merchant_id":"'+ this.merchant_id + '",' +
        '"service_id":"'+ this.service_id + '",' +
        '"cust_code":"'+ this.cust_code + '",' +
        '"sps_cust_no":"'+ this.sps_cust_no + '",' +
        '"sps_payment_no":"'+ this.sps_payment_no + '",' +
        '"order_id":"'+ this.order_id + '",' +
        '"item_id":"'+ this.item_id + '",' +
        '"pay_item_id":"'+ this.pay_item_id + '",' +
        '"item_name":"'+ this.item_name + '",' +
        '"tax":"'+ this.tax + '",' +
        '"amount":"'+ this.amount + '",' +
        '"pay_type":"'+ this.pay_type + '",' +
        '"auto_charge_type":"'+ this.auto_charge_type + '",' +
        '"service_type":"'+ this.service_type + '",' +
        '"div_settele":"'+ this.div_settele + '",' +
        '"last_charge_month":"'+ this.last_charge_month + '",' +
        '"camp_type":"'+ this.camp_type + '",' +
        '"tracking_id":"'+ this.tracking_id + '",' +
        '"terminal_type":"'+ this.terminal_type + '",' +
        '"success_url":"'+ this.success_url + '",' +
        '"cancel_url":"'+ this.cancel_url + '",' +
        '"error_url":"'+ this.error_url + '",' +
        '"pagecon_url":"'+ this.pagecon_url + '",' +
        '"free1":"'+ this.free1 + '",' +
        '"free2":"'+ this.free2 + '",' +
        '"free3":"'+ this.free3 + '",' +
        '"resultOrderDetail":"'+ resultOrderDetail + '",' +
        '"request_date":"'+ this.request_date + '",' +
        '"limit_second":"'+ this.limit_second + '",' +
        '"hashkey":"'+ this.hashkey + '"}';
      return result;
    };
    this.toString = function() {

      let resultOrderDetail = "";
      const orderLength = this.orderDetail.length;
      for (let i = 0; i < orderLength; i++) {
        const o = this.orderDetail[i];
        resultOrderDetail = resultOrderDetail + o.toString();
      }

      let result =
        this.pay_method +
        this.merchant_id +
        this.service_id +
        this.cust_code +
        this.sps_cust_no +
        this.sps_payment_no +
        this.order_id +
        this.item_id +
        this.pay_item_id +
        this.item_name +
        this.tax +
        this.amount +
        this.pay_type +
        this.auto_charge_type +
        this.service_type +
        this.div_settele +
        this.last_charge_month +
        this.camp_type +
        this.tracking_id +
        this.terminal_type +
        this.success_url +
        this.cancel_url +
        this.error_url +
        this.pagecon_url +
        this.free1 +
        this.free2 +
        this.free3 +
        resultOrderDetail +
        this.request_date +
        this.limit_second +
        this.hashkey;
      return result;
    };
  }

  // 日時の取得
  function getYYYYMMDDHHMMSS(){
    let now = new Date();
    return now.getFullYear() + zeroPadding(now.getMonth() + 1) + zeroPadding(now.getDate()) +
      zeroPadding(now.getHours()) + zeroPadding(now.getMinutes()) + zeroPadding(now.getSeconds());
  }

  function zeroPadding(num) {
    if (num < 10) { num = "0" + num; }
    return num + "";
  }

  function feppost(order) {
    //let connectUrl = "https://stbfep.sps-system.com/f01/FepBuyInfoReceive.do";　//試験
    let connectUrl = "https://fep.sps-system.com/f01/FepBuyInfoReceive.do"; //本番
    let form =
      $('<form></form>',{action:connectUrl,target:'receiver',method:'POST',acceptCharset:'Shift_JIS'}).hide();
    form[0].acceptCharset = 'Shift_JIS';

    let body = $('body');
    body.append(form);
    form.append($('<input>',{type:'hidden',name:'pay_method'        ,value:order.pay_method                  }));
    form.append($('<input>',{type:'hidden',name:'merchant_id'       ,value:order.merchant_id                 }));
    form.append($('<input>',{type:'hidden',name:'service_id'        ,value:order.service_id                  }));
    form.append($('<input>',{type:'hidden',name:'cust_code'         ,value:order.cust_code                   }));
    form.append($('<input>',{type:'hidden',name:'sps_cust_no'       ,value:order.sps_cust_no                 }));
    form.append($('<input>',{type:'hidden',name:'sps_payment_no'    ,value:order.sps_payment_no              }));
    form.append($('<input>',{type:'hidden',name:'order_id'          ,value:order.order_id                    }));
    form.append($('<input>',{type:'hidden',name:'item_id'           ,value:order.item_id                     }));
    form.append($('<input>',{type:'hidden',name:'pay_item_id'       ,value:order.pay_item_id                 }));
    form.append($('<input>',{type:'hidden',name:'item_name'         ,value:order.item_name                   }));
    form.append($('<input>',{type:'hidden',name:'tax'               ,value:order.tax                         }));
    form.append($('<input>',{type:'hidden',name:'amount'            ,value:order.amount                      }));
    form.append($('<input>',{type:'hidden',name:'pay_type'          ,value:order.pay_type                    }));
    form.append($('<input>',{type:'hidden',name:'auto_charge_type'  ,value:order.auto_charge_type            }));
    form.append($('<input>',{type:'hidden',name:'service_type'      ,value:order.service_type                }));
    form.append($('<input>',{type:'hidden',name:'div_settele'       ,value:order.div_settele                 }));
    form.append($('<input>',{type:'hidden',name:'last_charge_month' ,value:order.last_charge_month           }));
    form.append($('<input>',{type:'hidden',name:'camp_type'         ,value:order.camp_type                   }));
    form.append($('<input>',{type:'hidden',name:'tracking_id'       ,value:order.tracking_id                 }));
    form.append($('<input>',{type:'hidden',name:'terminal_type'     ,value:order.terminal_type               }));
    form.append($('<input>',{type:'hidden',name:'success_url'       ,value:order.success_url                 }));
    form.append($('<input>',{type:'hidden',name:'cancel_url'        ,value:order.cancel_url                  }));
    form.append($('<input>',{type:'hidden',name:'error_url'         ,value:order.error_url                   }));
    form.append($('<input>',{type:'hidden',name:'pagecon_url'       ,value:order.pagecon_url                 }));
    form.append($('<input>',{type:'hidden',name:'free1'             ,value:order.free1                       }));
    form.append($('<input>',{type:'hidden',name:'free2'             ,value:order.free2                       }));
    form.append($('<input>',{type:'hidden',name:'free3'             ,value:order.free3                       }));
    form.append($('<input>',{type:'hidden',name:'free_csv'          ,value:order.free_csv                    }));
    form.append($('<input>',{type:'hidden',name:'request_date'      ,value:order.request_date                }));
    form.append($('<input>',{type:'hidden',name:'limit_second'      ,value:order.limit_second                }));
    form.append($('<input>',{type:'hidden',name:'hashkey'           ,value:order.hashkey                     }));
    form.append($('<input>',{type:'hidden',name:'sps_hashcode'      ,value:order.sps_hashcode                }));

    form.submit();
  }
</script>



// WEBPACK FOOTER //
// src/components/payments/PaymentWay.vue